import { Carousel } from '@mantine/carousel';
import {
  ActionIcon,
  Box,
  Button,
  Container,
  Flex,
  Grid,
  HoverCard,
  Image,
  Menu,
  Modal,
  Paper,
  Rating,
  Text,
  createStyles,
  useMantineTheme,
  Global,
} from '@mantine/core';
import {
  IconArrowsMaximize,
  IconHeart,
  IconMoneybag,
  IconPercentage,
  IconPlus,
  IconStar,
  IconStars,
  IconTrendingUp,
} from '@tabler/icons-react';
import { useContext, useEffect, useRef, useState } from 'react';
import data from './DummyData.json';
import { api } from '../../services/master.service';
import { image_url, is_mobile_view } from '../../config';
import { showErrorToast, showSuccessToast } from '../../utilities/Toast';
import { useNavigate } from 'react-router';
import { IconChevronRight } from '@tabler/icons';
import ProductCard from '../../components/ProductCard';
import CustomSlider from '../../components/CustomSlider';
import { useMediaQuery } from '@mantine/hooks';
import { CartContext } from '../../App';
import { qtyCalculator } from '../../utilities/Common'



const useStyles = createStyles((theme) => ({
  link: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    height: '100%',
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    textDecoration: 'none',
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    fontWeight: 500,
    fontSize: theme.fontSizes.sm,

    [theme.fn.smallerThan('sm')]: {
      height: 42,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },

    ...theme.fn.hover({
      backgroundColor:
        theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
    }),
  },

  subLink: {
    width: '100%',
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
    borderRadius: theme.radius.md,

    ...theme.fn.hover({
      backgroundColor:
        theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
    }),

    '&:active': theme.activeStyles,
  },

  dropdownFooter: {
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
    margin: `calc(${theme.spacing.md} * -1)`,
    marginTop: theme.spacing.sm,
    padding: `${theme.spacing.md} calc(${theme.spacing.md} * 2)`,
    paddingBottom: theme.spacing.xl,
    borderTop: `${1} solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1]
      }`,
  },

  hiddenMobile: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  hiddenDesktop: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },
}));

export default function Home() {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { classes } = useStyles();
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  const banner_view = is_mobile_view && !isMobileScreen;
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const { cartItemCount, setCartItemCount } = useContext(CartContext);

  const [trendingProducts, setTrendingProducts] = useState([]);
  const [quickViewModalVisible, setQuickViewModalVisible] = useState(false);
  const [heroBanners, setHeroBanners] = useState([]);
  const [bottomBanners, setBottomBanners] = useState([]);
  const [midBanners, setMidBanners] = useState([]);
  const [affliatorBanners, setAffliatorBanners] = useState([]);

  const [latestProducts, setLatestProducts] = useState([]);
  const [dealProducts, setDealProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [openStickyMenu, setOpenStickyMenu] = useState(false);

  const [shareModalOpen, setShareModalOpen] = useState(false);

const user = JSON.parse(localStorage.getItem('user') || '{}');
const referralCode = user?.referral_code || null;

const shareUrl =
  `https://play.google.com/store/apps/details?id=com.postulate.quzone&pcampaignid=web_share&ref=${referralCode}`;
  const shareMessage = `
🎉 Join Quzone & Get a Coupon!

Use my referral code during login:
👉 \`${referralCode}\`

🎁 You’ll get a coupon on signup.

Download the app here:
${shareUrl}
`;



  const addToCart = async (id, varient, unit = "pkt", isVarient) => {
    await api
      .add_to_cart({
        product_id: id,
        quantity: qtyCalculator(1, varient, isVarient ? unit : 'pkt', isVarient),
        varientSlug: `${varient}${isVarient ? unit : 'pkt'} x 1`
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          setCartItemCount(res.data.data?.cartitem.length);
          showSuccessToast({
            title: 'Success',
            message: 'Item successfully added to cart.',
          });
        } else {
          if (res.data.code === 401) {
            navigate('/login');
            showErrorToast({
              title: 'Warning',
              message: 'You have to login to add items to cart.',
            });
          } else {
            showErrorToast({
              title: 'Error',
              message: res.data.message,
            });
          }
        }
      })
      .catch((err) => {
        showErrorToast({
          title: 'Error',
          message: err.message,
        });
      });
  };

  useEffect(() => {
    setTrendingProducts(data.data);

    api.get_home_products({ filter: 'latest' }).then((res) => {
      console.log(res.data.data);
      setLatestProducts(res.data.data);
    });

    api.get_home_products({ filter: 'deals' }).then((res) => {
      console.log(res.data.data);
      setDealProducts(res.data.data);
    });

    api.get_home_products({ filter: 'featured' }).then((res) => {
      console.log(res.data.data);
      setFeaturedProducts(res.data.data);
    });

    api.get_banners().then((res) => {
      console.log(res.data.data);
      let hero_banners = res.data.data.filter((e) => e.home_banner === true);
      setHeroBanners(hero_banners);
      let bottom_banners = res.data.data.filter((e) => e.bottom_banner === true);
      setBottomBanners(bottom_banners);
      let mid_banners = res.data.data.filter((e) => e.mid_banner === true);
      setMidBanners(mid_banners);
      let affliator_banners = res.data.data.filter((e) => e.affliator_banner === true);
      setAffliatorBanners(affliator_banners);
    });
  }, []);

  useEffect(() => {
    api.get_categories().then((res) => {
      console.log(res.data.data);
      setCategories(res.data.data);
    });
  }, []);

  return (
    <div style={{ overflow: 'hidden', marginTop: isMobileScreen ? '135px' : '170px' }}>
      <Global
        styles={(theme) => ({
          '.slick-prev::before, .slick-next::before': {
            color: '#5bc680  !important',
            fontSize: '20px',

          },
          '.mantine-4o0tuq': {
            color: 'white',
            backgroundColor: '#5bc680  !important',
          },

        })}
      />
      <Container size={'xl'}>


        {/* =========================
   STICKY FLOATING MENU
   ========================= */}
    <Box
  sx={{
    position: 'fixed',
    right: openStickyMenu ? 18 : -18,
    top: isMobileScreen ? 200 : 220,
    zIndex: 9999,
    transition: 'right 0.35s ease',
  }}
>
 <Paper
  shadow="xl"
  radius="xl"
  px={openStickyMenu ? 26 : 8}
  py={openStickyMenu ? 22 : 8}
  sx={{
    minWidth: openStickyMenu ? 180 : 44,   // 🔒 width unchanged
    minHeight: openStickyMenu ? 140 : 44,  // ✅ HEIGHT INCREASED
    background: openStickyMenu
      ? 'linear-gradient(145deg, #22c55e, #16a34a, #15803d)'
      : '#5bc680',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: openStickyMenu ? 18 : 0,          // ⬅️ vertical breathing space
    border: openStickyMenu
      ? '1px solid rgba(255,255,255,0.25)'
      : 'none',
    transition: 'all 0.35s ease',
  }}
>




            {/* ARROW BUTTON – TOP */}
   <ActionIcon
  radius="xl"
  size="lg"
  onClick={() => setOpenStickyMenu(!openStickyMenu)}
  sx={{
    backgroundColor: openStickyMenu ? '#ecfdf5' : '#ffffff',
    color: '#166534',
    boxShadow: openStickyMenu
      ? '0 6px 18px rgba(22,163,74,0.45)'
      : '0 6px 18px rgba(0,0,0,0.25)',
    transition: 'all 0.35s ease',
  }}
>
  <IconChevronRight
    size={20}
    style={{
      transform: openStickyMenu ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.45s ease',
    }}
  />
</ActionIcon>




            {/* MENU ITEMS */}
{openStickyMenu && (
  <Flex direction="column" gap={16} mt={10} w="100%">

    {/* SHARE */}
    <Box
      onClick={() => setShareModalOpen(true)}
      sx={{
        position: 'relative',
        padding: '14px 18px',
        borderRadius: 18,
        background:
          'linear-gradient(145deg, rgba(255,255,255,0.18), rgba(255,255,255,0.08))',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        cursor: 'pointer',
        overflow: 'hidden',
        transition: 'all 0.35s cubic-bezier(.25,.8,.25,1)',
        boxShadow:
          '0 12px 30px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(255,255,255,0.25)',

        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: 18,
          padding: 1,
          background:
            'linear-gradient(120deg, rgba(255,255,255,0.6), rgba(255,255,255,0))',
          WebkitMask:
            'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
          WebkitMaskComposite: 'xor',
          pointerEvents: 'none',
        },

        '&:hover': {
          transform: 'translateY(-3px) scale(1.02)',
          boxShadow:
            '0 18px 45px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.35)',
        },
      }}
    >
      <Box
        sx={{
          width: 38,
          height: 38,
          borderRadius: '50%',
          background:
            'linear-gradient(135deg, #ecfdf5, #bbf7d0)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          boxShadow: '0 6px 14px rgba(0,0,0,0.35)',
          animation: 'pulse 2.4s infinite',
        }}
      >
        🔗
      </Box>

      <Flex direction="column">
        <Text fw={700} size="sm">
          Share
        </Text>
        <Text size="xs" opacity={0.7}>
          Invite friends
        </Text>
      </Flex>
    </Box>
        {/* REFERRAL */}
<Box
  onClick={() =>
    navigate('/account', { state: { openTab: 'referral' } })
  }
  sx={{
    position: 'relative',
    padding: '14px 18px',
    borderRadius: 18,
    background:
      'linear-gradient(145deg, rgba(255,255,255,0.18), rgba(255,255,255,0.08))',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    cursor: 'pointer',
    overflow: 'hidden',
    transition: 'all 0.35s cubic-bezier(.25,.8,.25,1)',
    boxShadow:
      '0 12px 30px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(255,255,255,0.25)',

    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 18,
      padding: 1,
      background:
        'linear-gradient(120deg, rgba(255,255,255,0.6), rgba(255,255,255,0))',
      WebkitMask:
        'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
      WebkitMaskComposite: 'xor',
      pointerEvents: 'none',
    },

    '&:hover': {
      transform: 'translateY(-3px) scale(1.02)',
      boxShadow:
        '0 18px 45px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.35)',
    },
  }}
>
  <Box
    sx={{
      width: 38,
      height: 38,
      borderRadius: '50%',
      background:
        'linear-gradient(135deg, #eef2ff, #c7d2fe)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 18,
      boxShadow: '0 6px 14px rgba(0,0,0,0.35)',
      animation: 'pulse 2.4s infinite',
    }}
  >
    🎁
  </Box>

  <Flex direction="column">
    <Text fw={700} size="sm">
      Referral
    </Text>
    <Text size="xs" opacity={0.7}>
      Earn coupons
    </Text>
  </Flex>
</Box>

    {/* STREAK */}
    <Box
      onClick={() =>
        navigate('/account', { state: { openTab: 'streak' } })
      }
      sx={{
        position: 'relative',
        padding: '14px 18px',
        borderRadius: 18,
        background:
          'linear-gradient(145deg, rgba(255,255,255,0.18), rgba(255,255,255,0.08))',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
        gap: 14,
        cursor: 'pointer',
        overflow: 'hidden',
        transition: 'all 0.35s cubic-bezier(.25,.8,.25,1)',
        boxShadow:
          '0 12px 30px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(255,255,255,0.25)',

        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: 18,
          padding: 1,
          background:
            'linear-gradient(120deg, rgba(255,255,255,0.6), rgba(255,255,255,0))',
          WebkitMask:
            'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
          WebkitMaskComposite: 'xor',
          pointerEvents: 'none',
        },

        '&:hover': {
          transform: 'translateY(-3px) scale(1.02)',
          boxShadow:
            '0 18px 45px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.35)',
        },
      }}
    >
      <Box
        sx={{
          width: 38,
          height: 38,
          borderRadius: '50%',
          background:
            'linear-gradient(135deg, #fff7ed, #fed7aa)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          boxShadow: '0 6px 14px rgba(0,0,0,0.35)',
          animation: 'pulse 2.4s infinite',
        }}
      >
        🔥
      </Box>

      <Flex direction="column">
        <Text fw={700} size="sm">
          Streak
        </Text>
        <Text size="xs" opacity={0.7}>
          Track rewards
        </Text>
      </Flex>
    </Box>

  </Flex>
)}




          </Paper>
        </Box>


        {/* Top Slider */}
        <Box my={5}>
          <Grid>
            <Grid.Col span={12} md={2} lg={2}>
              {/* Categories display */}
              <Grid>
                {affliatorBanners?.map((e, i) => (
                  <Grid.Col
                    span={6}
                    md={12}
                    lg={12}
                    onClick={() => {
                      if (categories.length > 0) {
                        if (e.product !== null) navigate(`/product?id=${e.product}`);
                      }
                    }}
                    onMouseOver={(e) => {
                      e.target.style.cursor = 'pointer';
                    }}
                  >
                    <img
                      alt=""
                      src={image_url + e.image}
                      width={'100%'}
                      height={'200px'}
                      style={{
                        objectFit: 'contain',
                      }}
                    />
                  </Grid.Col>
                ))}
              </Grid>
            </Grid.Col>
            <Grid.Col span={12} md={10} lg={10}>
              <CustomSlider slidesToShow={1}>
                {heroBanners.map((e) => (
                  <div
                    h={400}
                    onClick={() => {
                      if (categories.length > 0) {
                        if (e.product !== null) navigate(`/product?id=${e.product}`);
                      }
                    }}
                    onMouseOver={(e) => {
                      e.target.style.cursor = 'pointer';
                    }}
                  >
                    <img
                      alt=""
                      src={image_url + e.image}
                      width={'100%'}
                      height={isMobileScreen ? (banner_view ? 400 : 'auto') : 400}
                      style={{
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                ))}
              </CustomSlider>
            </Grid.Col>
          </Grid>
        </Box>

        {/* Best Seller Products */}
        <Box my={5}>
          <Flex align="center" my={10}>
            <IconStar color="red" size={'30px'} style={{ opacity: 0.5 }} />
            <Text fw={'700'} size="xl" ml={10} mb={0}>
              Latest Products
            </Text>
          </Flex>
          <Box mb={15}>
            <Carousel
              slideSize={isMobileScreen ? '50%' : '25%'}
              loop={true}
              align="start"
              slidesToScroll={1}
              slideGap={'sm'}
              withControls={isMobileScreen ? false : true}
              dragFree
            >
              {latestProducts.map((e) => {
                return (
                  <Carousel.Slide>
                    <Box>
                      <ProductCard object={e} addToCart={addToCart} />
                    </Box>
                  </Carousel.Slide>
                );
              })}
            </Carousel>
          </Box>
        </Box>

        {/* Mid banner  - 1 */}
        <Box my={10}>
          <Text fw={700} my={10}>
            Deals you don't want to miss!
          </Text>
          <Grid>
            <Grid.Col span={12}>
              <CustomSlider slidesToShow={isMobileScreen ? 1 : 2}>
                {midBanners.map((e) => (
                  <div>
                    <Box
                      mr={5}
                      ml={5}
                      p={2}
                      style={{
                        border: `2px solid ${theme.colors.brand[2]}`,
                        borderRadius: '6px',
                      }}
                      onClick={() => {
                        if (categories.length > 0) {
                          if (e.product !== null) navigate(`/product?id=${e.product}`);
                        }
                      }}
                      onMouseOver={(e) => {
                        e.target.style.cursor = 'pointer';
                      }}
                    >
                      <img
                        alt=""
                        src={image_url + e.image}
                        width={'100%'}
                        height={'100%'}
                        style={{
                          objectFit: 'cover',
                        }}
                      />
                    </Box>
                  </div>
                ))}
              </CustomSlider>
            </Grid.Col>
          </Grid>
        </Box>

        {/* Deal Products */}
        <Box my={5}>
          <Flex align="center" my={10}>
            <IconPercentage color="red" size={'30px'} style={{ opacity: 0.5 }} />
            <Text fw={'700'} size="xl" ml={10} mb={0}>
              Deal Products
            </Text>
          </Flex>
          <Box>
            <Carousel
              slideSize={isMobileScreen ? '50%' : '25%'}
              loop={true}
              align="start"
              slidesToScroll={1}
              slideGap={'sm'}
              withControls={isMobileScreen ? false : true}
              dragFree
            >
              {dealProducts.map((e) => {
                return (
                  <Carousel.Slide>
                    <Box w={'100%'} mr={20} pb={20}>
                      <ProductCard object={e} addToCart={addToCart} />
                    </Box>
                  </Carousel.Slide>
                );
              })}
            </Carousel>
          </Box>
        </Box>

        {/* Categories */}
        <Box>
          <Text fw={700}>Explore our Trending Categories</Text>
          <Grid
            my={5}
            h={isMobileScreen ? 165 * 3 : 165}
            // justify={'space-between'}
            // wrap={'wrap'}
            // gap={isMobileScreen ? 8 : 'lg'}
            sx={{ overflow: 'hidden' }}
          >
            {categories?.map((e, i) => (
              <Grid.Col span={'auto'}>
                {
                  <Box
                    bg={'transparent'}
                    w={'100%'}
                    miw={160}
                    h={160}
                    sx={{
                      '&:hover': {
                        border: `2px solid ${theme.colors.brand[5]}`,
                      },
                      cursor: 'pointer',
                    }}
                    style={{
                      borderRadius: '6px',
                      backgroundImage: `url(${categories.length > 0 ? image_url + e.image : ''
                        })`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      backgroundSize: 'cover',
                    }}
                    onClick={() => {
                      if (categories.length > 0) {
                        navigate(`/category?id=${e.id}`);
                      }
                    }}
                  >
                    <Flex
                      h={'100%'}
                      direction={'column'}
                      align={'center'}
                      justify={'center'}
                    >
                      <Text
                        ta={'center'}
                        fz={16}
                        fw={700}
                        color={'black'}
                        p={6}
                        style={{ borderRadius: '30px' }}
                        bg={'rgba(255, 255, 255,0.6)'}
                      >
                        {categories.length > 0 ? e.title : ''}
                        <img
                          src="https://img.icons8.com/pastel-glyph/64/0c4a6e/move-right.png"
                          width={30}
                        />
                      </Text>
                    </Flex>
                  </Box>
                }
              </Grid.Col>
            ))}

            {/* <Box
              bg={'transparent'}
              w={160}
              h={160}
              sx={{
                '&:hover': {
                  border: `2px solid ${theme.colors.brand[5]}`,
                },
                cursor: 'pointer',
              }}
              style={{
                borderRadius: '6px',
                backgroundImage: `url(${
                  categories.length > 0 ? image_url + categories[0].image : ''
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
              onClick={() => {
                if (categories.length > 0) {
                  navigate(`/category?id=${categories[0].id}`);
                }
              }}
            >
              <Flex h={'100%'} direction={'column'} align={'center'} justify={'center'}>
                <Text
                  ta={'center'}
                  fz={16}
                  fw={700}
                  color={'black'}
                  p={6}
                  style={{ borderRadius: '30px' }}
                  bg={'rgba(255, 255, 255,0.6)'}
                >
                  {categories.length > 0 ? categories[0].title : ''}
                  <img
                    src="https://img.icons8.com/pastel-glyph/64/0c4a6e/move-right.png"
                    width={30}
                  />
                </Text>
              </Flex>
            </Box>

            <Box
              bg={'transparent'}
              w={160}
              h={160}
              sx={{
                '&:hover': {
                  border: `2px solid ${theme.colors.brand[5]}`,
                },
                cursor: 'pointer',
              }}
              style={{
                borderRadius: '6px',
                backgroundImage: `url(${
                  categories.length > 1 ? image_url + categories[1].image : ''
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
              onClick={() => {
                if (categories.length > 1) {
                  navigate(`/category?id=${categories[1].id}`);
                }
              }}
            >
              <Flex h={'100%'} direction={'column'} align={'center'} justify={'center'}>
                <Text
                  ta={'center'}
                  fz={16}
                  fw={700}
                  color={'black'}
                  p={6}
                  style={{ borderRadius: '30px' }}
                  bg={'rgba(255, 255, 255,0.6)'}
                >
                  {categories.length > 1 ? categories[1].title : ''}
                  <img
                    src="https://img.icons8.com/pastel-glyph/64/0c4a6e/move-right.png"
                    width={30}
                  />
                </Text>
              </Flex>
            </Box>

            <Box
              bg={'transparent'}
              w={160}
              h={160}
              sx={{
                '&:hover': {
                  border: `2px solid ${theme.colors.brand[5]}`,
                },
                cursor: 'pointer',
              }}
              style={{
                borderRadius: '6px',
                backgroundImage: `url(${
                  categories.length > 2 ? image_url + categories[2].image : ''
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
              onClick={() => {
                if (categories.length > 2) {
                  navigate(`/category?id=${categories[2].id}`);
                }
              }}
            >
              <Flex h={'100%'} direction={'column'} align={'center'} justify={'center'}>
                <Text
                  ta={'center'}
                  fz={16}
                  fw={700}
                  color={'black'}
                  p={6}
                  style={{ borderRadius: '30px' }}
                  bg={'rgba(255, 255, 255,0.6)'}
                >
                  {categories.length > 2 ? categories[2].title : ''}
                  <img
                    src="https://img.icons8.com/pastel-glyph/64/0c4a6e/move-right.png"
                    width={30}
                  />
                </Text>
              </Flex>
            </Box>

            <Box
              sx={{
                '&:hover': {
                  border: `2px solid ${theme.colors.brand[5]}`,
                },
                cursor: 'pointer',
              }}
              bg={'transparent'}
              w={160}
              h={160}
              style={{
                borderRadius: '6px',
                backgroundImage: `url(${
                  categories.length > 3 ? image_url + categories[3].image : ''
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
              onClick={() => {
                if (categories.length > 3) {
                  navigate(`/category?id=${categories[3].id}`);
                }
              }}
            >
              <Flex h={'100%'} direction={'column'} align={'center'} justify={'center'}>
                <Text
                  ta={'center'}
                  fz={16}
                  fw={700}
                  color={'black'}
                  p={6}
                  style={{ borderRadius: '30px' }}
                  bg={'rgba(255, 255, 255,0.6)'}
                >
                  {categories.length > 3 ? categories[3].title : ''}
                  <img
                    src="https://img.icons8.com/pastel-glyph/64/0c4a6e/move-right.png"
                    width={30}
                  />
                </Text>
              </Flex>
            </Box>

            <Box
              bg={'transparent'}
              w={160}
              h={160}
              sx={{
                '&:hover': {
                  border: `2px solid ${theme.colors.brand[5]}`,
                },
                cursor: 'pointer',
              }}
              style={{
                borderRadius: '6px',
                backgroundImage: `url(${
                  categories.length > 4 ? image_url + categories[4].image : ''
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
              onClick={() => {
                if (categories.length > 4) {
                  navigate(`/category?id=${categories[4].id}`);
                }
              }}
            >
              <Flex h={'100%'} direction={'column'} align={'center'} justify={'center'}>
                <Text
                  ta={'center'}
                  fz={16}
                  fw={700}
                  color={'black'}
                  p={6}
                  style={{ borderRadius: '30px' }}
                  bg={'rgba(255, 255, 255,0.6)'}
                >
                  {categories.length > 4 ? categories[4].title : ''}
                  <img
                    src="https://img.icons8.com/pastel-glyph/64/0c4a6e/move-right.png"
                    width={30}
                  />
                </Text>
              </Flex>
            </Box>

            <Box
              bg={'transparent'}
              w={160}
              h={160}
              style={{
                borderRadius: '6px',
                backgroundImage: `url(${
                  categories.length > 5 ? image_url + categories[5].image : ''
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
              onClick={() => {
                if (categories.length > 5) {
                  navigate(`/category?id=${categories[5].id}`);
                }
              }}
              sx={{
                '&:hover': {
                  border: `2px solid ${theme.colors.brand[5]}`,
                },
                cursor: 'pointer',
              }}
            >
              <Flex h={'100%'} direction={'column'} align={'center'} justify={'center'}>
                <Text
                  ta={'center'}
                  fz={16}
                  fw={700}
                  color={'black'}
                  p={6}
                  style={{ borderRadius: '30px' }}
                  bg={'rgba(255, 255, 255,0.6)'}
                >
                  {categories.length > 5 ? categories[5].title : ''}
                  <img
                    src="https://img.icons8.com/pastel-glyph/64/0c4a6e/move-right.png"
                    width={30}
                  />
                </Text>
              </Flex>
            </Box> */}
            {/* <Box
              bg={'transparent'}
              w={160}
              h={160}
              style={{
                borderRadius: '6px',
                backgroundImage: `url(${
                  categories.length > 6 ? image_url + categories[6].image : ''
                })`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
              onClick={() => {
                if (categories.length > 6) {
                  navigate(`/category?id=${categories[6].id}`);
                }
              }}
              sx={{
                '&:hover': {
                  border: `2px solid ${theme.colors.brand[5]}`,
                },
                cursor: 'pointer',
              }}
            >
              <Flex h={'100%'} direction={'column'} align={'center'} justify={'center'}>
                <Text
                  ta={'center'}
                  fz={16}
                  fw={700}
                  color={'black'}
                  p={6}
                  style={{ borderRadius: '30px' }}
                  bg={'rgba(255, 255, 255,0.6)'}
                >
                  {categories.length > 6 ? categories[6].title : ''}
                  <img
                    src="https://img.icons8.com/pastel-glyph/64/0c4a6e/move-right.png"
                    width={30}
                  />
                </Text>
              </Flex>
            </Box> */}
          </Grid>
        </Box>

        {/* Trending Products */}
        <Box my={10}>
          <Flex align="center" mt={10}>
            <IconTrendingUp color="red" size={'30px'} style={{ opacity: 0.5 }} />
            <Text fw={'700'} size="xl" ml={10} mb={0}>
              Trending Products
            </Text>
          </Flex>
          <Box mt={10}>
            <Carousel
              slideSize={isMobileScreen ? '50%' : '25%'}
              loop={true}
              align="start"
              slidesToScroll={1}
              slideGap={'sm'}
              withControls={isMobileScreen ? false : true}
              dragFree
            >
              {featuredProducts.map((e) => {
                return (
                  <Carousel.Slide>
                    <Box w={'100%'} mr={20} pb={20}>
                      <ProductCard object={e} addToCart={addToCart} />
                    </Box>
                  </Carousel.Slide>
                );
              })}
            </Carousel>
          </Box>
        </Box>

        {/* Bottom Banner */}
        <Box my={5}>
          <Grid>
            <Grid.Col span={12}>
              <CustomSlider slidesToShow={1}>
                {bottomBanners.map((e) => (
                  <div
                    onClick={() => {
                      if (categories.length > 0) {
                        if (e.product !== null) navigate(`/product?id=${e.product}`);
                      }
                    }}
                    onMouseOver={(e) => {
                      e.target.style.cursor = 'pointer';
                    }}
                  >
                    <Image
                      alt=""
                      src={image_url + e.image}
                      width={'100%'}
                      height={'100%'}
                      style={{
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                ))}
              </CustomSlider>
            </Grid.Col>
          </Grid>
        </Box>
      </Container>



  <Modal
  opened={shareModalOpen}
  onClose={() => setShareModalOpen(false)}
  centered
  radius="xl"
  size="sm"
  overlayProps={{
    blur: 3,
    opacity: 0.55,
  }}
  title={
    <Flex align="center" gap={8}>
      <span style={{ fontSize: 22 }}>🔗</span>
      <Text fw={700} size="lg">
        Share this page
      </Text>
    </Flex>
  }
>
  <Flex direction="column" gap={18}>

    {/* SHARE BUTTONS */}
    <Flex gap={12}>
      {/* WhatsApp */}
    <Button
  component="a"
  href={`https://wa.me/?text=${encodeURIComponent(shareMessage.trim())}`}
  target="_blank"
  fullWidth
  radius="lg"
  size="md"
  sx={{
    background: 'linear-gradient(135deg, #25D366, #1ebe5d)',
    boxShadow: '0 6px 16px rgba(37,211,102,0.35)',
    '&:hover': {
      transform: 'translateY(-1px)',
    },
  }}
>
  <Flex align="center" gap={8}>
    <Image
      src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
      width={20}
      height={20}
      alt="WhatsApp"
    />
    <Text fw={600}>WhatsApp</Text>
  </Flex>
</Button>


      {/* Facebook */}
     {/* <Button
  component="a"
  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`}
  target="_blank"
  fullWidth
  radius="lg"
  size="md"
  sx={{
    background: 'linear-gradient(135deg, #1877F2, #145dbf)',
    boxShadow: '0 6px 16px rgba(24,119,242,0.35)',
    '&:hover': {
      transform: 'translateY(-1px)',
    },
  }}
>
  <Flex align="center" gap={8}>
    <Image
      src="https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg"
      width={18}
      height={18}
      alt="Facebook"
      
    />
    <Text fw={600}>Facebook</Text>
  </Flex>
</Button> */}

    </Flex>

    {/* COPY LINK */}
    <Paper
      radius="lg"
      p={10}
      withBorder
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#f8fafc',
      }}
    >
      <Text
  size="sm"
  color="dimmed"
  lineClamp={1}
  sx={{
    overflowWrap: "anywhere",
    wordBreak: "break-all",
  }}
>
  {shareMessage.trim()}
</Text>

      <Button
        variant="light"
        radius="md"
        onClick={() => {
          navigator.clipboard.writeText(shareMessage.trim());
          showSuccessToast({
            title: "Copied",
            message: "Link copied to clipboard",
          });
        }}
      >
        📋 Copy
      </Button>
    </Paper>

  </Flex>
</Modal>


      <Modal
        centered
        opened={quickViewModalVisible}
        onClose={() => {
          setQuickViewModalVisible(false);
        }}
        size={'800px'}
        title="Product Title"
      >
        {/* Modal content */}
      </Modal>
    </div>
  );
}